import { NgModule } from '@angular/core';
import { ApolloModule } from 'apollo-angular';
import { LocalStorageModule } from 'angular-2-local-storage';

import { UserService } from './user.service';
import { UserGuard } from './user.guard';

@NgModule({
  imports: [
    ApolloModule,
    LocalStorageModule.withConfig({
      prefix: 'qas',
      storageType: 'localStorage'
    })
  ],
  providers: [
    UserService,
    UserGuard
  ]
})
export class CoreModule {
}
